import {
  ActionIcon,
  Anchor,
  Button,
  Divider,
  Group,
  Stack,
  Tooltip,
} from "@mantine/core";
import { IconChevronRight, IconX } from "@tabler/icons-react";
import { useMemo } from "react";
import { useWindowScroll } from "@mantine/hooks";
import { useUIStore } from "../../stores/UIStore";
import AllSwitcher from "../Footer/AllSwitcher";
import { useProfileStore, useSessionStore } from "../../stores/UserStore";
import HeaderProfile from "./HeaderProfile";
import Notifications from "./Notifications";
import { getPermission } from "../../functions/utilFunctions";
import { QuestionIcon } from "../../components/Icons/SvgIcons";
import LanguageChanger from "../../pages/unprotected/LanguageChanger";
import MaintenanceNotifier from "../../components/View/MaintenanceNotifier";

const Header = () => {
  const navbarClosed = useUIStore((s) => s.navbarClosed);
  const setNavbarClosed = useUIStore((s) => s.setNavbarClosed);
  const headerClosed = useUIStore((s) => s.headerClosed);
  const unswitchedProfile = useProfileStore((s) => s.unswitchedProfile);
  const profile = useProfileStore((s) => s.profile);
  const user_switch = useSessionStore((s) => s.user_switch);

  const canSwitch = useMemo(() => {
    let p = user_switch ? unswitchedProfile : profile;
    let params = new URLSearchParams(location.search);
    let apiKey = localStorage.getItem("api_key");
    if (
      !p?.permissions?.find((x) => x.name === "switchOrganizationUser")
        ?.value &&
      !p?.permissions?.find((x) => x.name === "switchTeamUser")?.value &&
      p?.level === "user"
    ) {
      return false;
    }
    if (apiKey?.length > 6 && localStorage.getItem("allow_switch") !== "true") {
      return false;
    }
    if (
      apiKey === "false" &&
      params.get("apiKey") &&
      (params.get("allowSwitch") === "false" || !params.get("allowSwitch"))
    ) {
      return false;
    }
    return true;
  }, [user_switch, unswitchedProfile, profile]);

  const [scroll] = useWindowScroll();

  const campaignOpened = useUIStore((s) => s.campaignOpened);
  const setCampaignOpened = useUIStore((s) => s.setCampaignOpened);
  const handleClick = () => {
    if (campaignOpened) {
      setCampaignOpened(false);
    }
    setNavbarClosed(!navbarClosed);
  };

  return (
    <Stack
      gap={0}
      pos={"sticky"}
      flex={1}
      w={"100%"}
      h={61}
      bg={scroll.y > 0 ? "#fff" : "var(--mantine-color-primary-2)"}
      style={{
        transition: "all ease .3s",
        zIndex: 2,
        boxShadow: scroll.y > 0 ? "#00000012 6px 0 4px" : "none",
        borderBottom: scroll.y > 0 ? "1px solid #00000012" : "0",
        marginTop: headerClosed ? -60 : 0,
      }}
    >
      <Group
        align={"center"}
        gap={0}
        h={"100%"}
        py={0}
        w={"100%"}
        wrap="nowrap"
      >
        {getPermission("displaySideMenu") && (
          <ActionIcon
            onClick={handleClick}
            h={48}
            w={48}
            radius={16}
            variant="subtle"
            ml={8}
          >
            {navbarClosed ? (
              <IconChevronRight size={28} style={{ strokeWidth: 1.1 }} />
            ) : (
              <IconX size={28} style={{ strokeWidth: 1.1 }} />
            )}
          </ActionIcon>
        )}

        {/* <GlobalSearch /> */}

        <Group ml={"auto"}>
          <LanguageChanger header />

          <Tooltip label="Support">
            <Button
              variant="subtle"
              px={12}
              size="lg"
              component={Anchor}
              href={"/support"}
              target="_blank"
            >
              <QuestionIcon />
            </Button>
          </Tooltip>

          <Notifications />

          {/* <LanguageChanger is2 /> */}
        </Group>

        <Divider orientation="vertical" my={16} mx={"md"} opacity={0.75} />

        <HeaderProfile />

        {canSwitch && <AllSwitcher />}
      </Group>

      {/* <MaintenanceNotifier /> */}
    </Stack>
  );
};

export default Header;
